import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import { USER_ROLES } from "../../constants";
import AppLogo from "./../../assets/imgs/yamaha-logo-white.png";
import * as S from "./styles";

export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { user, logout } = useAuth();

  const getActiveClass = useCallback(
    (route) => {
      if (route === location.pathname || location.pathname.includes(route)) {
        return "active";
      }

      return "";
    },
    [location]
  );

  return (
    <S.Container>
      <div id="logo-container" onClick={() => navigate("/")}>
        <img src={AppLogo} alt="Yamaha - Revs Your Heart" />
        <h1>Check Yamaha</h1>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {user?.role === USER_ROLES.ADMIN ? (
          <nav id="admin-nav-container">
            <span
              onClick={() => navigate("/concessionarias")}
              className={getActiveClass("/concessionarias")}
            >
              Concessionárias
            </span>
            <span
              onClick={() => navigate("/campanhas")}
              className={getActiveClass("/campanhas")}
            >
              Campanhas
            </span>
          </nav>
        ) : (
          <>
            <div id="store-hello-container">
              <h4>Olá, {user.title}</h4>
            </div>
            <div id="store-hello-container-mobile">
              <p>Olá, {user.title}</p>
            </div>
          </>
        )}
        <button id="logout-button" onClick={logout}>
          Sair
        </button>
      </div>
    </S.Container>
  );
};
